"use client";

import { useConsentManagementVisibility } from "@aleksundshantu/aunds-cookie-plugin-react";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

type ConsentManagementButtonProps = {
  index: number;
  title: string;
};
export const ConsentManagementButton = ({
  index,
  title,
}: ConsentManagementButtonProps) => {
  const { show: showConsentManagement } = useConsentManagementVisibility();
  const { label } = useGlobalContext();

  return (
    <button
      role="menuitem"
      key={"footer-menu-link-" + index}
      className="footer-link button-reset"
      onClick={showConsentManagement}
      id={`menuitem-${index}`}
      aria-label={label("global", "aria_label", "footer_cookie_setting", {
        en: "Opens the window for personal settings",
        de: "Öffnet das Fenster für persönliche Einstellungen",
      })}
    >
      {title}
    </button>
  );
};
